import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from "@chakra-ui/react";
import { connect } from "react-redux";
import PrimaryColorButton from "src/components/PrimaryColorButton";
import { resetImpersonatorState } from "src/redux/actions";

function ImpersonationModal({
  clearImpersonation,
  continueImpersonationSession,
  isTimedOut,
  resetImpersonatorState,
}) {
  if (isTimedOut) {
    return (
      <Modal isOpen={true} isCentered onClose={resetImpersonatorState}>
        <ModalOverlay />

        <ModalContent>
          <ModalBody mt={3}>
            <p>You have been logged out of an impersonated session.</p>
          </ModalBody>
          <ModalFooter
            display="flex"
            justifyContent={"center"}
            alignItems={"center"}
          >
            <PrimaryColorButton
              onClick={resetImpersonatorState}
              colorModeOverride="light"
            >
              Continue
            </PrimaryColorButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }

  return (
    <Modal isOpen={true} isCentered onClose={continueImpersonationSession}>
      <ModalOverlay />

      <ModalContent>
        <ModalBody mt={3}>
          <p>You are about to be logged out of your impersonated session.</p>
        </ModalBody>
        <ModalFooter
          display="flex"
          justifyContent={"center"}
          alignItems={"center"}
        >
          <PrimaryColorButton
            onClick={continueImpersonationSession}
            colorModeOverride="light"
            marginRight="16px"
          >
            Continue Session
          </PrimaryColorButton>
          <Button
            onClick={() => {
              clearImpersonation();
              resetImpersonatorState();
            }}
            variant={"solid"}
          >
            Log Out
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export const mapDispatchToProps = (dispatch) => ({
  resetImpersonatorState: () => dispatch(resetImpersonatorState()),
});

export default connect(null, mapDispatchToProps)(ImpersonationModal);
